var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts-warp"},[_c('div',{staticClass:"echart-content"},[_c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.resize),expression:"resize"}],staticStyle:{"padding-top":"10px","height":"100%","box-sizing":"border-box"},attrs:{"id":_vm.getId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }